<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex">

            <section class="mu-d-flex mu-flex-row">

                <h1 class="mu-mb-00">Deployments details</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
            <section>

            </section>
        </div>
        <div>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Process engine</li>
                <li>
                    <router-link :to="CONTEXT_PATH + '/processengine/deployment'">Deployments</router-link>
                </li>
                <li aria-current="page">{{ deploymentName }} ({{ deploymentId }})</li>
                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>
        <div class="mcc-card">
            <div class="mcc-card__body">

           
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                            </circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>

        <div class="mcc-row">

            <div class="mcc-col ">

                    <div v-if="fetchCall">
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--info mcc-alert--compact" v-show="!deploymentInfo.deployment.undeployed" >
                            <mcc-icon name="time" aria-hidden="true"></mcc-icon>
                            <span>
                                <strong>Deployment time : </strong>{{ deploymentTime }}
                            </span>
                        </mcc-alert>
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-show="deploymentInfo.deployment.undeployed">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>

                            <span>Application has been undeployed.</span>

                        </mcc-alert>

                    </div>

                    <div class="mcc-tabs mcc-tabs--compact mcc-tabs--pill  mu-pb-06">
                        <input type="radio" id="as-default-tab1" name="as-default-tab-control" checked="">
                        <input type="radio" id="as-default-tab2" name="as-default-tab-control">
                        <ul role="tablist" class="mu-mb-05">
                            <li role="tab">
                                <label for="as-default-tab1" tabindex="0">
                                    <span>Resources</span>
                                </label>
                            </li>
                            <li role="tab">
                                <label for="as-default-tab2" tabindex="0">
                                    <span>Process definition</span>
                                </label>
                            </li>
                        </ul>
                        <div role="tabpanel">
                                <mcc-data-table id="resourceList" ref="resourceListTable"></mcc-data-table>
                        </div>
                        <div role="tabpanel">
                                <mcc-data-table id="definitionList" ref="definitionListTable"></mcc-data-table>
                        </div>
                    </div>

                

            </div>
        </div>
    </div>
        </div>

    </div>

</div>
</template>

<script>
import DeploymentAPI from "../../../services/DeploymentAPI";
import constantMessages from "../../../messages";
import Table from "@advanced/component-mosaic-table";
import constants from "../../../constants";
import Utils from "@/script_utils";
import {
    EventBus
} from "../../../services/event-bus";

export default {
    name: "DeploymentEdit",
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["deployment.edit"],
            deploymentId: this.$route.params.id,
            updateCall: true,
            fetchCall: false,
            deploymentInfo: {},
            processDefinitions: [],
            deploymentTime: "",
            resourceList: [],
            definitionList: [],
            definitionTableObj: null,
            definitionPageSize: 10,
            deploymentName: "",
            resourceListPageSize: 10,
            resourceListTableObj: null

        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        DeploymentAPI.getDeploymentDetails(self.deploymentId).then(result => {
            self.fetchCall = true;

            self.deploymentInfo = result;
            if (result.deployment.deploymentDate != null && result.deployment.deploymentDate != "") {
                self.deploymentTime = new Date(result.deployment.deploymentDate).toLocaleString("en-GB").replace(/\,/g, '');
            }
            if (result.deploymentName != null) {
                self.deploymentName = result.deploymentName;
            }
            if (result.deployedProcesses != null) {
                self.definitionList = {
                    totalCount: result.deployedProcesses.recordsTotal,
                    data: result.deployedProcesses.data
                };
            }
            if (result.deploymentResources != null) {
                self.resourceList = {
                    totalCount: result.deploymentResources.length,
                    data: result.deploymentResources
                };
            }
            self.initDefinitionListTable();

            self.initResourceListTable();

            let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.deployment.details"] + " - " + self.deploymentName;
            EventBus.$emit("update-pageTitle", pageTitle);
        });
    },
    methods: {
        initDefinitionListTable() {
            let self = this;
            const table = document.getElementById("definitionList");
            window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No process definitions found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.definitionPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        id: {
                            type: "string",
                            title: "ID",
                            sortable: true,
                            columnSearch: false,
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor " onclick="${(e) => self.redirectToLink(rowData)}" >${rowData.id}</button>`;
                            }
,                            color: "link",
                        },
                        key: {
                            type: "string",
                            title: "Key",
                            sortable: true,
                            columnSearch: false
                        },
                        name: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            columnSearch: false
                        },
                        category: {
                            type: "string",
                            title: "Category",
                            sortable: true,
                            columnSearch: false
                        },
                        version: {
                            type: "string",
                            title: "Version",
                            sortable: true,
                            columnSearch: false
                        },
                        statusString: {
                            type: "string",
                            title: "Active",
                            sortable: true,
                            columnSearch: false
                        }
                    }
                },
                data: (

                ) => {
                    return self.definitionList;
                },
                onAction: (table, action, obj) => {
                    let rowData = obj[0].rowData;
                    this.$router.push(
                        self.CONTEXT_PATH + "/processengine/processdefinitions/" + rowData.id
                    );

                }
            });
        },
        redirectToLink(rowData) {
            this.$router.push(this.CONTEXT_PATH + "/processengine/processdefinitions/" + rowData.id)
        },
        initResourceListTable() {
            let self = this;
            const table = document.getElementById("resourceList");
            window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No resources found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.resourceListPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        id: {
                            type: "string",
                            title: "Name",
                            sortable: true,
                            columnSearch: false
                        },
                        mediaType: {
                            type: "string",
                            title: "Media type",
                            sortable: true,
                            columnSearch: false
                        },
                        type: {
                            type: "string",
                            title: "Type",
                            sortable: true,
                            columnSearch: false
                        },
                        actions: {
                            type: "object",
                            title: "Export",
                            properties: {
                                export: {
                                    type: "string",
                                    format: "button",
                                    title: " Export ",
                                }
                            }
                        }
                    }
                },
                data: (

                ) => {
                    return self.resourceList;
                },
                onAction: (table, action, obj) => {
                    let rowData = obj[0].rowData;
                    let self = this;
                    let resourceId = rowData.id
                        .substr(
                            rowData.id
                            .lastIndexOf("\\") + 1,
                            rowData.id.length);
                    let encodedURI = encodeURI(resourceId);
                    let resourceIdSub = resourceId
                        .substr(
                            resourceId
                            .lastIndexOf(".") + 1,
                            resourceId.length);
                    let queryStr = constants.BASE_URL + "/deployments/" + self.deploymentId + '/resourcedata/' + encodedURI + '/' + resourceIdSub;

                    const link = document.createElement('a');
                    link.href = queryStr;
                    link.click()

                }
            });
        }
    }
}
</script>
